import { HoldbackReportList } from '../../../components/Report';

export function HoldbackReports() {
  return <HoldbackReportList />;
}
